import { useState, useEffect } from 'react'
import { Table } from 'react-bootstrap'
import './FinalUserGrid.scss'
import { useTranslation } from 'react-i18next';
import { Spinner } from "react-bootstrap";
import { User } from '../../utils/models/User';

const FinalUserGrid = (props: { users: User[], loading: boolean, onCopy: () => void }) => {
    const { t } = useTranslation();
    const [users, setUsers] = useState<User[]>(props.users)

    useEffect(() => {
        setUsers(props.users.sort((a, b) => a.iduser - b.iduser))
    }, [props.users])

    return (
        <div className="p-2 rounded-1" id='gridFinalUserContainer'>
            <div className='d-flex justify-content-between align-items-center'>
                <p className="mt-1 ms-1 h4 text-start flex-grow-1">{t('Users')}</p>
            </div>

            {props.loading ? <div className="text-center pt-5"><Spinner animation="border" variant="success" /></div> : (users.length > 0) ? <div className="table-responsive scrollFinalUsers">
                <Table hover className='gridsStyle'>
                    <thead>
                        <tr>
                            <th>{t('Name')}</th>
                            <th>{t('Surnames')}</th>
                            <th>{t('Email')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((user: User, index: number) => (
                            <tr key={index} className={user.active ? 'tableLine' : 'table-secondary'}>
                                <td>{user.name}</td>
                                <td>{user.surname}</td>
                                <td>{user.email}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div> : <p className='text-center'>{t('NoUsers')}</p>}
        </div >
    )
}

export default FinalUserGrid